{
  "PercentageFormatString": "|1 %",
  "NAME": "FieldsTab"
}